/**
 * Manage the how Access Tokens are being stored and retrieved from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instance.
 **/
const TokenService = {
  getToken(key) {
    const b = document.cookie.match('(^|[^;]+)\\s*' + key + '\\s*=\\s*([^;]+)')
    const cookie = b ? b.pop() : ''
    return cookie
  },

  saveToken(key, value) {
    document.cookie = `${key}=${value};path=/;domain=${window.location.hostname};expires=86400;` // one day
  },

  removeToken(key) {
    document.cookie = `${key}=;path=/;domain=${window.location.hostname};expires=Thu, 01 Jan 1970 00:00:00 UTC;` // past
  }
}

export { TokenService }
